import { Component, computed, inject, input } from '@angular/core';
import { ButtonComponent } from 'app/shared/button/button.component';
import { MyHistoryScreen } from 'app/my-history/my-history-screen';
import { ChapterService } from 'app/my-history/chapter/chapter.service';
import { StoryService } from 'app/my-history/story/story.service';

@Component({
  selector: 'app-add-story',
  standalone: true,
  imports: [ButtonComponent],
  templateUrl: './add-story.component.html',
  styleUrls: ['./add-story.component.scss'],
})
export class AddStoryComponent {
  private chapterService = inject(ChapterService);
  private storyService = inject(StoryService);

  screen = input<MyHistoryScreen>();
  isButtonEnabled = computed(() => this.chapterService.chapters().length || this.chapterService.chapterFacets().length);

  onAdd(): void {
    this.storyService.openStory();
  }
}
